export interface IPushNotification {
  id: string;
  message: string;
  senderId: string;
  type: string;
  pictureUrl: string;
  postId?: string;
  createdAt?: Date;
  readAt?: Date;
  isRead?: boolean;
}

export function WithAvatar({
  notification,
}: {
  notification: IPushNotification;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        src={notification.pictureUrl}
        alt="Avatar"
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          marginRight: 10,
          objectFit: "cover",
        }}
      />
      <p className="text-base text-zinc-500">{notification.message}</p>
    </div>
  );
}
